export const ctaLoadingClass = "cta--loading";
